import { cB } from '../../../../_utils/cssr/index'

export default cB('base-wave', `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: inherit;
`)
